const compareGroups = (groupOne, groupTwo) => {

  const getRules = (group, direction) => {

    let IpPermissions = 'IpPermissions';
    let id = 1;

    if (direction === 'out') {
      IpPermissions = 'IpPermissionsEgress';
    };

    const rulesList = group[IpPermissions].reduce((acc, rule) => {

      const newRules = [];

      let protocol = rule.IpProtocol;
      let portRange = `${rule.FromPort}-${rule.ToPort}`;

      if (rule.IpProtocol === '-1') {
        protocol = 'All';
        portRange = 'All';
      } else if (rule.FromPort < 0 || rule.ToPort < 0) {
        portRange = 'N/A';
      }

      rule.IpRanges.forEach(ipRule => {
        let ipRange = ipRule.CidrIp;
        newRules.push({protocol, ipRange, portRange, id});
        id++;
      });

      rule.Ipv6Ranges.forEach(ipRule => {
        let ipRange = ipRule.CidrIpv6;
        newRules.push({protocol, ipRange, portRange, id});
        id++;
      });

      acc.push(...newRules);

      return acc;

    }, []);

    rulesList.sort((a, b) => {
      if ([a.protocol, b.protocol].sort()[0] === a.protocol) return -1;
      else if (a.protocol === b.protocol) {
        if ([a.portRange, b.portRange].sort()[0] === a.portRange) return -1;
        else if (a.portRange === b.portRange) {
          if ([a.ipRange, b.ipRange].sort()[0] === a.ipRange) return -1;
          else return 1;
        } else {
          return 1;
        }
      } else return 1;
    });

    return rulesList;

  };

  const groupOneInRules = getRules(groupOne, 'in');
  const groupTwoInRules = getRules(groupTwo, 'in');
  const groupOneOutRules = getRules(groupOne, 'out');
  const groupTwoOutRules = getRules(groupTwo, 'out');

  groupOneInRules.forEach(rule => {

    groupTwoInRules.forEach(targetRule => {
      if (
        rule.protocol === targetRule.protocol
        && rule.ipRange === targetRule.ipRange
        && rule.portRange === targetRule.portRange
      ) {
        rule.match = targetRule.id;
        targetRule.match = rule.id;
      };
    });

  });

  groupOneOutRules.forEach(rule => {

    groupTwoOutRules.forEach(targetRule => {
      if (
        rule.protocol === targetRule.protocol
        && rule.ipRange === targetRule.ipRange
        && rule.portRange === targetRule.portRange
      ) {
        rule.match = targetRule.id;
        targetRule.match = rule.id;
      };
    });

  });

  const protocols = [...groupOneInRules, ...groupTwoInRules, ...groupTwoOutRules, ...groupOneOutRules].reduce((acc, rule) => {
    if (!acc.includes(rule.protocol)) acc.push(rule.protocol);
    return acc;
  }, []);

  return {
    groupOneInRules,
    groupTwoInRules,
    groupTwoOutRules,
    groupOneOutRules,
    protocols
  };

};

export default compareGroups;


// WEBPACK FOOTER //
// ./src/components/universal/utils/compareGroups.js